export default __webpack_public_path__ + "static/media/logo.42424ce5.png";